function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgDoctor = function SvgDoctor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("circle", {
    style: {
      fill: "#F5D7B7"
    },
    cx: 80.55,
    cy: 213.88,
    r: 30.898
  }), React.createElement("circle", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    cx: 80.55,
    cy: 213.88,
    r: 30.898
  }), React.createElement("circle", {
    style: {
      fill: "#F5D7B7"
    },
    cx: 431.45,
    cy: 213.88,
    r: 30.898
  }), React.createElement("circle", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    cx: 431.45,
    cy: 213.88,
    r: 30.898
  }), React.createElement("path", {
    style: {
      fill: "#E8E9EA"
    },
    d: "M394.3,512c7.271,0,13.069-6.204,12.431-13.448C399.926,421.28,335.04,360.68,256,360.68 s-143.926,60.6-150.731,137.872C104.632,505.796,110.429,512,117.7,512H394.3z"
  }), React.createElement("path", {
    style: {
      fill: "#BDC0C3"
    },
    d: "M359.7,484.201h-46.938c-2.887,0-5.227-2.34-5.227-5.227v-13.633c0-2.887,2.34-5.227,5.227-5.227 H359.7c2.887,0,5.227,2.34,5.227,5.227v13.633C364.927,481.861,362.587,484.201,359.7,484.201z"
  }), React.createElement("path", {
    style: {
      fill: "#B3E7FF"
    },
    d: "M256,360.68c-18.098,0-35.449,3.186-51.535,9.012L229.942,512h52.115l25.478-142.308 C291.449,363.866,274.098,360.68,256,360.68z"
  }), React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M307.535,392.236v21.221l-44.44,29.319c-4.304,2.84-9.887,2.84-14.191,0 l-44.44-29.319v-21.221H307.535z"
  }), React.createElement("path", {
    style: {
      fill: "#F5D7B7"
    },
    d: "M307.535,373.86v21.221l-44.44,29.319c-4.304,2.84-9.887,2.84-14.191,0l-44.44-29.319V373.86H307.535 z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#76B7EB"
    },
    d: "M220.13,374.289L240.874,512H220.13l-37.099-35.957c-2.493-2.416-2.551-6.397-0.13-8.886l8.467-8.7 c1.848-1.899,2.103-4.836,0.611-7.025l-15.816-23.197c-1.48-2.171-1.8-4.93-0.857-7.382l17.911-46.563h26.913V374.289z"
  }), React.createElement("path", {
    style: {
      fill: "#76B7EB"
    },
    d: "M291.87,374.289L271.126,512h20.745l37.099-35.957c2.493-2.416,2.551-6.397,0.13-8.886l-8.467-8.7 c-1.848-1.899-2.103-4.836-0.611-7.025l15.816-23.197c1.48-2.171,1.8-4.93,0.857-7.382l-17.911-46.563H291.87V374.289z"
  })), React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M256,360.68c-33.938,0-65.261,11.18-90.503,30.048 c27.051,14.947,57.846,23.426,90.503,23.426s63.452-8.48,90.503-23.426C321.261,371.86,289.938,360.68,256,360.68z"
  }), React.createElement("path", {
    style: {
      fill: "#F5D7B7"
    },
    d: "M431.446,213.877c0-101.912-78.55-184.528-175.446-184.528S80.554,111.965,80.554,213.877 S159.104,395.081,256,395.081S431.446,315.789,431.446,213.877z"
  }), React.createElement("g", null, React.createElement("ellipse", {
    style: {
      fill: "#F28B74"
    },
    cx: 148.88,
    cy: 257.36,
    rx: 35.3,
    ry: 28.11
  }), React.createElement("ellipse", {
    style: {
      fill: "#F28B74"
    },
    cx: 363.12,
    cy: 257.36,
    rx: 35.3,
    ry: 28.11
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M166.662,236.832c-4.142,0-7.5-3.357-7.5-7.5v-14.83c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5 v14.83C174.162,233.475,170.804,236.832,166.662,236.832z"
  }), React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M345.338,236.832c-4.142,0-7.5-3.357-7.5-7.5v-14.83c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5 v14.83C352.838,233.475,349.48,236.832,345.338,236.832z"
  }), React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M256,248.22c-11.195,0-21.841-4.849-29.208-13.304c-2.721-3.122-2.396-7.86,0.727-10.581 c3.122-2.722,7.86-2.396,10.582,0.727c4.518,5.184,11.042,8.157,17.899,8.157c6.857,0,13.382-2.974,17.899-8.157 c2.721-3.125,7.458-3.449,10.582-0.727c3.123,2.721,3.448,7.459,0.727,10.581C277.841,243.371,267.195,248.22,256,248.22z"
  })), React.createElement("path", {
    style: {
      opacity: 0.05,
      enableBackground: "new"
    },
    d: "M256,29.349c-96.896,0-175.446,82.616-175.446,184.528 S159.104,395.081,256,395.081c22.571,0,44.144-4.306,63.962-12.195c-146.218,2.219-181.142-99.939-187.067-186.852 c-0.24-3.523,1.444-6.866,4.35-8.872c10.851-7.495,20.545-18.61,24.633-34.625c26.953,29.425,161.272,79.065,268.532,41.282 C420.905,101.343,346.451,29.349,256,29.349z"
  }), React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M435.096,189.186c6.437-1.686,10.511-8.085,9.269-14.622C426.86,82.41,349.06,12.733,256,12.733 c-95.287,0-174.586,73.049-189.528,168.482c-0.645,4.122,2.005,8.102,6.078,9.004c27.534,6.094,74.21-10.108,89.329-37.681 c2.098-3.826,7.05-4.983,10.596-2.439C208.46,175.91,346.585,212.362,435.096,189.186z"
  }), React.createElement("path", {
    style: {
      fill: "#76B7EB"
    },
    d: "M86.665,126.921h338.699c6.402,0,10.514-6.785,7.577-12.474 c-6.559-12.706-14.322-24.592-23.116-35.508c-3.479-4.319-8.705-6.859-14.252-6.859H116.425c-5.557,0-10.791,2.552-14.271,6.884 c-8.845,11.01-16.573,22.908-23.069,35.488C76.149,120.139,80.266,126.921,86.665,126.921z"
  }), React.createElement("circle", {
    style: {
      fill: "#E8E9EA"
    },
    cx: 255.48,
    cy: 65.718,
    r: 65.718
  }), React.createElement("circle", {
    style: {
      fill: "#BDC0C3"
    },
    cx: 255.48,
    cy: 65.718,
    r: 26.351
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDoctor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doctor.41a9bb5c.svg";
export { ForwardRef as ReactComponent };